const checkHaikom = () => {
  const token = localStorage.getItem('bmsToken') || ''
  return token.length > 20
}

export default checkHaikom



// WEBPACK FOOTER //
// ./src/utils/checkHaikom.js